<template>
 <div class="main">
   <!--<section class="page page-subpage">-->
    <!--<vue-simplebar class="page page-subpage">-->
    <transition appear name="turnIn">
    <simplebar class="page page-subpage" data-simplebar-auto-hide="true" v-bind:class="{ 'linkIsClicked' : linkClicked }">

    <!-- <nav class="navigation">
      <ul class="menu menu-rsvp">
        <li><router-link to="/rsvp">RSVP</router-link></li>
      </ul>

      <ul class="menu menu-left">
        <li><router-link to="/schema">Schema</router-link></li>
        <li class="current"><router-link to="/florens">Florens</router-link></li>
      </ul>

      <ul class="menu menu-center">
        <li><router-link to="/rsvp">RSVP</router-link></li>
      </ul>

      <ul class=" menu menu-right">
        <li><router-link to="/ceremoni">Ceremoni</router-link></li>
        <li><router-link to="/middag">Middag</router-link></li>
      </ul>
    </nav> -->

    <navigation @link-clicked="linkClickedFunc" v-bind:linkClickedC="linkClicked"></navigation>

    <hr class="page-hr">

    <h1>Florens</h1>

    <figure class="page-florens-img">
      <!--<img src="../assets/davidochfrida.png" width="100%" height="auto" alt="David och Frida"/>-->
      <!--<img src="../assets/terrassen-opt.jpg" width="100%" height="auto" alt="Terrassen"/>-->
      <img src="../assets/florens3.jpg" width="100%" height="auto" alt="Terrassen"/>

    </figure>

    <p class="page-ingress">Vi har många fina minnen från våra besök i Florens. När vi frågade oss själva vad den ultimata platsen att ha vårt bröllop skulle vara blev Florens ett självklart val.</p>

    <hr class="hr-icons"/>

    <h2>Boende</h2>
    <p>Florens är en turistvänlig stad, med många hotell och boendemöjligheter att välja mellan.</p>
    <p><a href="https://www.hotelsantamarianovella.it/" title="Läs mer på hotellets hemsida" target="_blank">Santa Maria Novella Hotel</a> är hotellet där ceremonin kommer att hållas, och där brudparet kommer att bo.</p>

    <!--<p>&#9753; &#10087;</p>-->

    <hr class="hr-icons"/>

    <h2>Kommunikationer</h2>
    <p>Från flygplatsen går det (förutom taxi) att ta buss in till centralstationen (Firenze Santa Maria Novella). Bussen tar ca. 20 min. och kostar runt 10 EUR per person. Det kan vara bra att ha kontanter till bussen.</p>
    <p>Från centralstationen är det ca. 5 min gångväg till Santa Maria Novella Hotel, och ca. 15-20 min gångväg till centrala Florens.</p>

    <hr class="hr-icons"/>

    <h2>Turistattraktioner</h2>
    <p>Katedralen <a href="https://www.museumflorence.com/monuments/1-cathedral" title="Mer info om att besöka katedralen" target="_blank">Santa Maria del Fiore</a> är svår att missa. Konstmuséet <a href="https://www.uffizi.it/en/the-uffizi" title="Läs mer på galleriets hemsida" target="_blank">Uffizierna</a> (med bl.a. Botticellis Venus Födelse) rekommenderas. Konstmuséet <a href="http://www.galleriaaccademiafirenze.beniculturali.it/galleria/" title="Mer info om att besöka museet" target="_blank">Galleria dell’Accademia</a> visar bl.a. originalversionen av Michelangelo’s David staty.</p>
    <p><a href="https://www.uffizi.it/en/pitti-palace" target="_blank" title="Mer info om att besöka museet">Palazzo Pitti</a> innehåller ett flertal muséer med både konst och historiska föremål.</p>

    <p>Vi gillar också den botaniska trädgården <a href="https://www.uffizi.it/en/boboli-garden" target="_blank" title="Mer info om att besöka Boboli">Boboli</a> och saluhallen <a href="https://www.mercatocentrale.com/florence/how-it-works/" title="Mer om Mercato Centrale">Mercato Centrale</a> (gå gärna upp en trappa till deras food court).</p>

    <h2>Bra att veta</h2>
    <p>För alla muséer kan det vara bra att ordna entré och ev. guide i förväg för att undvika timslånga köer.</p>
    <p>Det finns väldigt få offentliga platser att sätta sig ner och vila, dricka vatten, eller äta något. Det är generellt förbjudet att sitta på t.ex. trappor eller trottoarer och vakter ser till att förbudet efterlevs. Det är även förbjudet att äta när man går på vissa gator i centrum under speciella tider.</p>

    <hr class="hr-icons"/>

    <h2>Väder</h2>
    <p>Håll ett öga på väderleksrapporten och var förberedd med exempelvis solskydd.</p>
    <p>&nbsp;</p>

    <!--</vue-simplebar>-->
    </simplebar>
    </transition>
   <!--</section>page-->
  </div><!--main-->
</template>

<script>

import simplebar from 'simplebar-vue';
// import 'simplebar/dist/simplebar.min.css'; //importerar denna som vanlig scss istället med copy paste för att få den inbakad i vanliga css filen

import Navigation from '../components/Nav.vue';

export default {
  name: 'florens',
  components: {
    simplebar,
    Navigation
  },

  data: function () {
    return {
      linkClicked: false
    };
  },

  methods: {
    linkClickedFunc (emittedvalue) {
      this.linkClicked = emittedvalue;
      // console.log('linkClickedFunc kördes');
      return this.linkClicked;
    }
  },
  mounted: function () {
    const pageSubpage = document.getElementsByClassName('page-subpage')[0];
    const pageSubpageHeight = document.getElementsByClassName('page-subpage')[0].offsetHeight + 15;
    // console.log(pageSubpageHeight);

    pageSubpage.style.height = pageSubpageHeight + 'px';
  }
};
</script>